import { validateEmailAddress } from 'helpers';

export const validateGeneralForm = (formData, setFormErrorMessages) => {
  setFormErrorMessages({});
  let isValid = true;
  const errors = {};

  if (!formData.firstName) {
    errors.firstName = 'First name is required';
    isValid = false;
  }
  if (!formData.lastName) {
    errors.lastName = 'Last name is required';
    isValid = false;
  }
  if (!formData.email) {
    errors.email = 'Email is required';
    isValid = false;
  }
  if (formData.email && !validateEmailAddress(formData.email)) {
    errors.email = 'Email is invalid';
    isValid = false;
  }
  if (!formData.orderContactRole) {
    errors.orderContactRole = 'Order Contact Role is required';
    isValid = false;
  }
  if (!formData.areaCode) {
    errors.areaCode = 'Area code is required';
    isValid = false;
  }
  if (!formData.phoneNumber) {
    errors.phoneNumber = 'Phone number is required';
    isValid = false;
  }

  if (formData.profilePhoto && formData.profilePhoto instanceof File) {
    const sizeMB = formData.profilePhoto.size / (1024 * 1024);
    if (sizeMB > 2) {
      errors.profilePhoto = 'Image file size exceeds 2MB';
      isValid = false;
    }
  }

  setFormErrorMessages(errors);
  return isValid;
};